<app-admin-list-page [title]="'Company pages' | translate">

</app-admin-list-page>
